import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--modal"
export default class extends Controller {
  // モダール表示はスコープが広いため、targetsでの設定は行わないが、
  // わかりやすくするため、HTML上は名前で指定する。
  // - data-resumin--modal-open-element-id-target="openするID"
  // - data-resumin--modal-close-element-id-target="closeするID"
  connect() {}

  open(e) {
    e.preventDefault();

    const targetId =
      e.currentTarget.dataset["resumin-ModalOpenElementIdTarget"];
    const modal = document.getElementById(targetId);
    if (modal) {
      modal.classList.add("is-open");
    }
  }

  close(e) {
    e.preventDefault();

    const targetId =
      e.currentTarget.dataset["resumin-ModalCloseElementIdTarget"];
    const modal = document.getElementById(targetId);
    if (modal) {
      this.closeModal(modal);
    }
  }

  // 背景（オーバーレイ）をクリックした場合のみモーダルを閉じる
  closeOnBackdrop(e) {
    // クリックされた要素が背景（c-modal）自体の場合のみ閉じる
    if (e.target === e.currentTarget) {
      this.closeModal(e.currentTarget);
      return;
    }

    // c-modal-white またはその子要素をクリックした場合は閉じない
    const modalWhite = e.currentTarget.querySelector(".c-modal-white");
    if (modalWhite && modalWhite.contains(e.target)) {
      return;
    }

    // c-modal-container 内のコンテンツ（bg-white など）をクリックした場合は閉じない
    // レジュサポなどc-modal-white がないモーダル用
    const modalContainer = e.currentTarget.querySelector(".c-modal-container");
    if (modalContainer) {
      const contentElements = Array.from(modalContainer.children);
      for (const contentElement of contentElements) {
        if (contentElement.contains(e.target)) {
          return;
        }
      }
    }

    // それ以外（背景やコンテナの余白部分）をクリックした場合は閉じる
    this.closeModal(e.currentTarget);
  }

  closeModal(modal) {
    modal.classList.remove("is-open");
    document.dispatchEvent(new CustomEvent("resumin--modal:closed"));
  }
}
